import { atom } from "recoil";

export const postIdCounterState = atom<number>({
  key: "postIdCounter",
  default: -1,
});
